<template>
    <el-dialog :title="title+'关联元数据'" width="40%" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" :model="form" ref="form" label-width="140px" :rules="dataRule" v-loading="loading"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent :disabled="method==='view'">
            <el-form-item label="组件类型：" prop="basicAssemblyId">
                <el-select v-model="form.basicAssemblyId" placeholder="请选择组件类型" filterable class="w100i" clearable @change="selBasicAssembly" :disabled="method!=='add'">
                    <el-option
                            :key="item.id"
                            :label="item.assemblyName"
                            :value="item.id"
                            v-for="item in basicAssemblyOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关联元数据：" prop="associationBasicId" v-show="form.basicAssemblyId && form.basicAssemblyId != '19' && form.basicAssemblyId != '20'">
                <el-select v-model="form.associationBasicId" placeholder="请选择元数据" filterable class="w100i" clearable @change="changeAssociationBasic" :disabled="method!=='add'">
                    <el-option
                            :key="item.id"
                            :label="item.basicName"
                            :value="item.id" :disabled="item.disabled"
                            v-for="item in associationBasicOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关联模板：" prop="associationBasicDataId" v-show="form.basicAssemblyId == '19' || form.basicAssemblyId == '20'">
                <el-select v-model="form.associationBasicDataId" placeholder="请选择元数据模板" filterable class="w100i" clearable @change="changeAssociationBasicDataId" :disabled="method!=='add'">
                    <el-option
                            :key="item.id"
                            :label="item.basicDataName"
                            :value="item.id" :disabled="item.disabled"
                            v-for="item in associationBasicDataOpt">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="新增同步：" prop="isSynced" v-if="form.basicAssemblyId == '19'">
                <el-radio-group v-model="form.isSynced">
                    <el-radio label="0">是</el-radio>
                    <el-radio label="1">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="别名：" prop="basicRename">
                <el-input v-model.trim="form.basicRename" placeholder="请输入别名（限10字）" clearable
                          maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="basicSort">
                <el-input-number v-model="form.basicSort" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="组件权限：" prop="basicForShow">
                <el-checkbox v-model="form.basicForShow" true-label="0" false-label="1" :disabled="form.basicForAdd == '0' || form.basicForEdit == '0'">可查看</el-checkbox>
                <el-checkbox v-model="form.basicForAdd" true-label="0" false-label="1" :disabled="form.basicForEdit == '0'" v-show="form.basicAssemblyId != '18' && form.basicAssemblyId != '19' && form.basicAssemblyId != '20'" @change="changeAdd">可新增</el-checkbox>
                <el-checkbox v-model="form.basicForEdit" true-label="0" false-label="1" v-show="form.basicAssemblyId != '18' && form.basicAssemblyId != '19' && form.basicAssemblyId != '20'" @change="changeEdit">可编辑</el-checkbox>
            </el-form-item>
            <el-form-item label="是否必填：" prop="basicRequired" v-show="form.basicAssemblyId != '18' && form.basicAssemblyId != '19' && form.basicAssemblyId != '20'">
                <el-switch v-model="form.basicRequired" active-value="0" inactive-value="1"></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">{{method != 'view' ? '取消' : '关闭'}}</el-button>
            <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            var validateBasicSort = (rule, value, callback) => {
                if (value && value > this.sortMax) {
                    callback(new Error('排序号最大值为'+ this.sortMax));
                }
                callback();
            };
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                sortMax: 0,
                basicAssemblyOpt: [],
                associationBasicOpt: [],
                associationBasicDataOpt: [],
                form: {
                    id: '',
                    basicDataId: "",
                    basicParentId: "",
                    basicAssemblyId: "",
                    associationBasicId: "",
                    associationBasicDataId: "",
                    isSynced: "",
                    basicRename: "",
                    basicSort: 1,
                    basicForShow: "0",
                    basicForAdd: "0",
                    basicForEdit: "0",
                    basicRequired: '0',
                },
                permissionName: '',
                dataRule: {
                    basicAssemblyId: [
                        {required: true, message: '组件类型不能为空', trigger: 'change'}
                    ],
                    associationBasicId: [
                        {required: true, message: '关联元数据不能为空', trigger: 'change'}
                    ],
                    associationBasicDataId: [
                        {required: false, message: '关联模板不能为空', trigger: 'change'}
                    ],
                    isSynced: [
                        {required: false, message: '新增同步不能为空', trigger: 'change'}
                    ],
                    basicRename: [
                        {required: true, message: '别名不能为空', trigger: 'change'}
                    ],
                    basicSort: [
                        {required: true, message: '排序不能为空', trigger: 'change'},
                        {validator: validateBasicSort, trigger: 'change'}
                    ],
                },
                curNavigation: {}
            }
        },
        methods: {
            // 初始化数据
            init(row, method, curNavigation) {
                this.getSortMax()
                this.loading = false
                this.curNavigation = curNavigation
                this.form.basicForShow = '0'
                this.form.basicForAdd = '0'
                this.form.basicForEdit = '0'
                this.form.isSynced = ''
                if(curNavigation.basicAssemblyId) {
                    this.form.basicDataId = curNavigation.basicDataId
                    this.form.basicParentId = curNavigation.id
                } else {
                    this.form.basicDataId = curNavigation.id
                    this.form.basicParentId = ''
                }
                this.method = method
                if (method === 'add') {
                    this.title = ''
                } else if (method === 'edit') {
                    this.title = '修改已'
                } else if (method === 'view') {
                    this.title = '查看已'
                }
                if (row) {
                    this.form.id = row.id
                } else {
                    this.form.id = ''
                }
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.getBasicAssembly()
                })
            },
            // 获取最大排序数
            getSortMax() {
                this.$axios(this.api.user.configKey + '/sort_max_number').then(data => {
                    if(data.status) {
                        this.sortMax = parseInt(data.data)
                    }
                })
            },
            // 获取组件类型
            getBasicAssembly() {
                this.loading = true
                this.$axios(this.api.metadata.selectAllMetadataBasicAssembly).then(res => {
                    if (res.status) {
                        this.basicAssemblyOpt = res.data
                        // 标题下面禁止关联标题
                        if(this.curNavigation.basicAssemblyId == '18') {
                            this.basicAssemblyOpt = this.basicAssemblyOpt.filter(item => item.id != '18' && item.id != '19' && item.id != '20')
                        }
                        if (this.method != 'add') {
                            this.getInfo()
                        } else {
                            this.loading = false
                        }
                    } else {
                        this.loading = false
                    }
                })
            },
            // 查询详情信息
            getInfo() {
                this.$axios(this.api.metadata.metadataBasicDataDetailGetById + '/' + this.form.id).then(res => {
                    if (res.status) {
                        this.form = this.recover(this.form, res.data);
                        this.selBasicAssembly(res.data.basicAssemblyId, 1)
                    } else {
                        this.loading = false
                    }
                })
            },
            // 选择组件类型  type：1数据回显
            selBasicAssembly(val, type) {
                if(type != 1) {
                    this.$set(this.form, 'basicRename', '')
                    this.form.associationBasicId = ''
                    this.form.associationBasicDataId = ''
                    // 标题、子表单、子模板
                    if(val == '18' || val == '19' || val == '20') {
                        this.$set(this.form, 'basicForAdd', '1')
                        this.$set(this.form, 'basicForEdit', '1')
                        this.$set(this.form, 'basicRequired', '1')
                    } else {
                        this.$set(this.form, 'basicForAdd', '0')
                        this.$set(this.form, 'basicForEdit', '0')
                        this.$set(this.form, 'basicRequired', '0')
                    }
                } else {
                    // 标题、子表单、子模板
                    if(val == '18' || val == '19' || val == '20') {
                        this.$set(this.form, 'basicForAdd', '1')
                        this.$set(this.form, 'basicForEdit', '1')
                    }
                }
                // 子表单、子模板
                if(val == '19') {
                    this.dataRule.isSynced[0].required = true
                }
                if(val == '19' || val == '20') {
                    this.dataRule.associationBasicId[0].required = false
                    this.dataRule.associationBasicDataId[0].required = true
                    this.excludeAssociationBasicDataId()
                } else {
                    this.dataRule.associationBasicId[0].required = true
                    this.dataRule.associationBasicDataId[0].required = false
                    this.selectBasicNotInBasicDataId()
                }
            },
            // 查询未关联过的元数据
            selectBasicNotInBasicDataId() {
                this.$axios(this.api.metadata.selectBasicNotInBasicDataId, {basicAssemblyId: this.form.basicAssemblyId, basicDataId: this.form.basicDataId}).then(res => {
                    if (res.status) {
                        this.associationBasicOpt = res.data
                        if (this.method != 'add') {
                            this.form = this.recover(this.form, this.form);
                        }
                    }
                    this.loading = false
                })
            },
            // 查询未关联的元数据模版
            excludeAssociationBasicDataId() {
                this.$axios(this.api.metadata.excludeAssociationBasicDataId, {basicDataId: this.form.basicDataId}).then(res => {
                    if (res.status) {
                        this.associationBasicDataOpt = res.data
                        if (this.method != 'add') {
                            this.form = this.recover(this.form, this.form);
                        }
                    }
                    this.loading = false
                })
            },
            // 选择关联元数据
            changeAssociationBasic(val) {
                let item = this.associationBasicOpt.filter(v => v.id == val)[0]
                this.$set(this.form, 'basicRename', item.basicName)
            },
            // 选择关联模板
            changeAssociationBasicDataId(val) {
                let item = this.associationBasicDataOpt.filter(v => v.id == val)[0]
                this.$set(this.form, 'basicRename', item.basicDataName)
            },
            // 可新增
            changeAdd(val) {
                if(val == 0) {
                    this.$set(this.form, 'basicForShow', '0')
                }
            },
            // 可编辑
            changeEdit(val) {
                if(val == 0) {
                    this.$set(this.form, 'basicForShow', '0')
                    this.$set(this.form, 'basicForAdd', '0')
                }
            },
            // 表单提交
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let api = this.api.metadata.associationMetadataBasicDataDetail, type = 'post'
                        if (this.method === 'edit') {
                            api = this.api.metadata.metadataBasicDataDetailUpdateById
                            type = 'put'
                        }
                        this.$axios(api, this.form, type).then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>
